export default "__VITE_ASSET__c5o$MOyp__"